export default __webpack_public_path__ + "static/LingoPass-5c5a2e7e0c66b8c5275b02df4b389718.svg";